// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file contact.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { ListInfo, ListInfoJson } from "./general_pb";
import { file_general } from "./general_pb";
import type { Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file contact.proto.
 */
export const file_contact: GenFile = /*@__PURE__*/
  fileDesc("Cg1jb250YWN0LnByb3RvEglyYWNjb29uYWkijQMKB0NvbnRhY3QSCgoCaWQYASACKAQSNAoVb3duZXJfb3JnYW5pemF0aW9uX2lkGAIgAigEUhVvd25lcl9vcmdhbml6YXRpb25faWQSLgoScGlja3VwX2xvY2F0aW9uX2lkGAMgASgEUhJwaWNrdXBfbG9jYXRpb25faWQSDAoEbmFtZRgEIAIoCRINCgVwaG9uZRgFIAEoCRINCgVlbWFpbBgGIAEoCRIQCghwb3NpdGlvbhgHIAEoCRIuChJjb250YWluZXJfZ3JvdXBfaWQYCCABKARSEmNvbnRhaW5lcl9ncm91cF9pZBIwChNjb250YWluZXJfZ3JvdXBfaWRzGAkgAygEUhNjb250YWluZXJfZ3JvdXBfaWRzEjQKFW5vdGlmaWNhdGlvbnNfZW5hYmxlZBgKIAEoCFIVbm90aWZpY2F0aW9uc19lbmFibGVkEjoKCmNyZWF0ZWRfYXQYZSACKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wUgpjcmVhdGVkX2F0IssCCg1Db250YWN0Q3JlYXRlEi4KEnBpY2t1cF9sb2NhdGlvbl9pZBgBIAEoBFIScGlja3VwX2xvY2F0aW9uX2lkEjQKFW93bmVyX29yZ2FuaXphdGlvbl9pZBgCIAIoBFIVb3duZXJfb3JnYW5pemF0aW9uX2lkEgwKBG5hbWUYAyACKAkSDQoFcGhvbmUYBCABKAkSDQoFZW1haWwYBSABKAkSEAoIcG9zaXRpb24YBiABKAkSLgoSY29udGFpbmVyX2dyb3VwX2lkGAcgASgEUhJjb250YWluZXJfZ3JvdXBfaWQSMAoTY29udGFpbmVyX2dyb3VwX2lkcxgJIAMoBFITY29udGFpbmVyX2dyb3VwX2lkcxI0ChVub3RpZmljYXRpb25zX2VuYWJsZWQYCiABKAhSFW5vdGlmaWNhdGlvbnNfZW5hYmxlZCLXAgoNQ29udGFjdFVwZGF0ZRIKCgJpZBgBIAIoBBI0ChVvd25lcl9vcmdhbml6YXRpb25faWQYAiABKARSFW93bmVyX29yZ2FuaXphdGlvbl9pZBIMCgRuYW1lGAMgASgJEg0KBXBob25lGAQgASgJEg0KBWVtYWlsGAUgASgJEhAKCHBvc2l0aW9uGAYgASgJEi4KEnBpY2t1cF9sb2NhdGlvbl9pZBgHIAEoBFIScGlja3VwX2xvY2F0aW9uX2lkEi4KEmNvbnRhaW5lcl9ncm91cF9pZBgIIAEoBFISY29udGFpbmVyX2dyb3VwX2lkEjAKE2NvbnRhaW5lcl9ncm91cF9pZHMYCSADKARSE2NvbnRhaW5lcl9ncm91cF9pZHMSNAoVbm90aWZpY2F0aW9uc19lbmFibGVkGAogASgIUhVub3RpZmljYXRpb25zX2VuYWJsZWQiZgoLQ29udGFjdExpc3QSJAoIY29udGFjdHMYASADKAsyEi5yYWNjb29uYWkuQ29udGFjdBIxCglsaXN0X2luZm8YAiABKAsyEy5yYWNjb29uYWkuTGlzdEluZm9SCWxpc3RfaW5mb0IGWgQuL3Bi", [file_general, file_google_protobuf_timestamp]);

/**
 * Contact always belongs to an organization, and covers zero or more of that
 * organization's container groups.
 * - container_group_ids non-empty: the person responsible for those groups
 * - container_group_ids empty: a contact of the organization as a whole
 * Primary contacts are referenced via primary_contact_id in ContainerGroup/Organization
 *
 * @generated from message raccoonai.Contact
 */
export type Contact = Message<"raccoonai.Contact"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * to be deprecated
   *
   * @generated from field: optional uint64 pickup_location_id = 3 [json_name = "pickup_location_id"];
   */
  pickupLocationId: bigint;

  /**
   * @generated from field: required string name = 4;
   */
  name: string;

  /**
   * @generated from field: optional string phone = 5;
   */
  phone: string;

  /**
   * @generated from field: optional string email = 6;
   */
  email: string;

  /**
   * @generated from field: optional string position = 7;
   */
  position: string;

  /**
   * Deprecated: the first entry of container_group_ids, kept for clients that
   * predate the many-to-many link. Read container_group_ids instead - a
   * customer often has several container groups on one pickup location, and
   * this field can only name one of them.
   *
   * @generated from field: optional uint64 container_group_id = 8 [json_name = "container_group_id"];
   */
  containerGroupId: bigint;

  /**
   * Every container group this contact answers for. A contact added from a
   * pickup location's card covers all of its own organization's groups on that
   * location, so this is normally the whole set rather than one entry.
   *
   * @generated from field: repeated uint64 container_group_ids = 9 [json_name = "container_group_ids"];
   */
  containerGroupIds: bigint[];

  /**
   * Gate for automatic notifications to this person, and to their platform
   * user if one matches. Off by default; unset reads as false.
   *
   * @generated from field: optional bool notifications_enabled = 10 [json_name = "notifications_enabled"];
   */
  notificationsEnabled: boolean;

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 101 [json_name = "created_at"];
   */
  createdAt?: Timestamp;
};

/**
 * Contact always belongs to an organization, and covers zero or more of that
 * organization's container groups.
 * - container_group_ids non-empty: the person responsible for those groups
 * - container_group_ids empty: a contact of the organization as a whole
 * Primary contacts are referenced via primary_contact_id in ContainerGroup/Organization
 *
 * @generated from message raccoonai.Contact
 */
export type ContactJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * to be deprecated
   *
   * @generated from field: optional uint64 pickup_location_id = 3 [json_name = "pickup_location_id"];
   */
  pickup_location_id?: string;

  /**
   * @generated from field: required string name = 4;
   */
  name?: string;

  /**
   * @generated from field: optional string phone = 5;
   */
  phone?: string;

  /**
   * @generated from field: optional string email = 6;
   */
  email?: string;

  /**
   * @generated from field: optional string position = 7;
   */
  position?: string;

  /**
   * Deprecated: the first entry of container_group_ids, kept for clients that
   * predate the many-to-many link. Read container_group_ids instead - a
   * customer often has several container groups on one pickup location, and
   * this field can only name one of them.
   *
   * @generated from field: optional uint64 container_group_id = 8 [json_name = "container_group_id"];
   */
  container_group_id?: string;

  /**
   * Every container group this contact answers for. A contact added from a
   * pickup location's card covers all of its own organization's groups on that
   * location, so this is normally the whole set rather than one entry.
   *
   * @generated from field: repeated uint64 container_group_ids = 9 [json_name = "container_group_ids"];
   */
  container_group_ids?: string[];

  /**
   * Gate for automatic notifications to this person, and to their platform
   * user if one matches. Off by default; unset reads as false.
   *
   * @generated from field: optional bool notifications_enabled = 10 [json_name = "notifications_enabled"];
   */
  notifications_enabled?: boolean;

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 101 [json_name = "created_at"];
   */
  created_at?: TimestampJson;
};

/**
 * Describes the message raccoonai.Contact.
 * Use `create(ContactSchema)` to create a new message.
 */
export const ContactSchema: GenMessage<Contact, {jsonType: ContactJson}> = /*@__PURE__*/
  messageDesc(file_contact, 0);

/**
 * Create a contact for an organization, optionally covering its container
 * groups. Which groups the contact ends up linked to is resolved in this order,
 * first field present wins:
 *
 *   container_group_ids  exactly those groups, no expansion;
 *   pickup_location_id   every container group of owner_organization_id on that
 *                        pickup location;
 *   container_group_id   the same expansion, taking the location from that one
 *                        group - so a client that can only name a single group
 *                        still gets the whole site;
 *   none of them         an organization-level contact with no group links.
 *
 * Groups belonging to another organization are never linked, whichever field
 * asked for them: the pickup location's card lists contacts per customer, and a
 * contact must not surface under a customer that is not its own.
 *
 * @generated from message raccoonai.ContactCreate
 */
export type ContactCreate = Message<"raccoonai.ContactCreate"> & {
  /**
   * Input only, never stored: it names the site whose groups to link.
   *
   * @generated from field: optional uint64 pickup_location_id = 1 [json_name = "pickup_location_id"];
   */
  pickupLocationId: bigint;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: required string name = 3;
   */
  name: string;

  /**
   * @generated from field: optional string phone = 4;
   */
  phone: string;

  /**
   * @generated from field: optional string email = 5;
   */
  email: string;

  /**
   * @generated from field: optional string position = 6;
   */
  position: string;

  /**
   * Expanded to the whole site, see the message comment.
   *
   * @generated from field: optional uint64 container_group_id = 7 [json_name = "container_group_id"];
   */
  containerGroupId: bigint;

  /**
   * @generated from field: repeated uint64 container_group_ids = 9 [json_name = "container_group_ids"];
   */
  containerGroupIds: bigint[];

  /**
   * Gate for automatic notifications to this person, and to their platform
   * user if one matches. Off by default.
   *
   * @generated from field: optional bool notifications_enabled = 10 [json_name = "notifications_enabled"];
   */
  notificationsEnabled: boolean;
};

/**
 * Create a contact for an organization, optionally covering its container
 * groups. Which groups the contact ends up linked to is resolved in this order,
 * first field present wins:
 *
 *   container_group_ids  exactly those groups, no expansion;
 *   pickup_location_id   every container group of owner_organization_id on that
 *                        pickup location;
 *   container_group_id   the same expansion, taking the location from that one
 *                        group - so a client that can only name a single group
 *                        still gets the whole site;
 *   none of them         an organization-level contact with no group links.
 *
 * Groups belonging to another organization are never linked, whichever field
 * asked for them: the pickup location's card lists contacts per customer, and a
 * contact must not surface under a customer that is not its own.
 *
 * @generated from message raccoonai.ContactCreate
 */
export type ContactCreateJson = {
  /**
   * Input only, never stored: it names the site whose groups to link.
   *
   * @generated from field: optional uint64 pickup_location_id = 1 [json_name = "pickup_location_id"];
   */
  pickup_location_id?: string;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: required string name = 3;
   */
  name?: string;

  /**
   * @generated from field: optional string phone = 4;
   */
  phone?: string;

  /**
   * @generated from field: optional string email = 5;
   */
  email?: string;

  /**
   * @generated from field: optional string position = 6;
   */
  position?: string;

  /**
   * Expanded to the whole site, see the message comment.
   *
   * @generated from field: optional uint64 container_group_id = 7 [json_name = "container_group_id"];
   */
  container_group_id?: string;

  /**
   * @generated from field: repeated uint64 container_group_ids = 9 [json_name = "container_group_ids"];
   */
  container_group_ids?: string[];

  /**
   * Gate for automatic notifications to this person, and to their platform
   * user if one matches. Off by default.
   *
   * @generated from field: optional bool notifications_enabled = 10 [json_name = "notifications_enabled"];
   */
  notifications_enabled?: boolean;
};

/**
 * Describes the message raccoonai.ContactCreate.
 * Use `create(ContactCreateSchema)` to create a new message.
 */
export const ContactCreateSchema: GenMessage<ContactCreate, {jsonType: ContactCreateJson}> = /*@__PURE__*/
  messageDesc(file_contact, 1);

/**
 * @generated from message raccoonai.ContactUpdate
 */
export type ContactUpdate = Message<"raccoonai.ContactUpdate"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: optional uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: optional string name = 3;
   */
  name: string;

  /**
   * @generated from field: optional string phone = 4;
   */
  phone: string;

  /**
   * @generated from field: optional string email = 5;
   */
  email: string;

  /**
   * @generated from field: optional string position = 6;
   */
  position: string;

  /**
   * to be deprecated
   *
   * @generated from field: optional uint64 pickup_location_id = 7 [json_name = "pickup_location_id"];
   */
  pickupLocationId: bigint;

  /**
   * Deprecated: replaces the whole set with this single group. Send
   * container_group_ids instead.
   *
   * @generated from field: optional uint64 container_group_id = 8 [json_name = "container_group_id"];
   */
  containerGroupId: bigint;

  /**
   * Replaces the contact's groups outright when non-empty. An empty list means
   * "leave the links alone", because proto2 cannot tell it apart from an unset
   * field - whether a contact belongs to a site or to the organization as a
   * whole is decided when it is created.
   *
   * @generated from field: repeated uint64 container_group_ids = 9 [json_name = "container_group_ids"];
   */
  containerGroupIds: bigint[];

  /**
   * Gate for automatic notifications to this person, and to their platform
   * user if one matches. Unset leaves the current value unchanged.
   *
   * @generated from field: optional bool notifications_enabled = 10 [json_name = "notifications_enabled"];
   */
  notificationsEnabled: boolean;
};

/**
 * @generated from message raccoonai.ContactUpdate
 */
export type ContactUpdateJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: optional uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: optional string name = 3;
   */
  name?: string;

  /**
   * @generated from field: optional string phone = 4;
   */
  phone?: string;

  /**
   * @generated from field: optional string email = 5;
   */
  email?: string;

  /**
   * @generated from field: optional string position = 6;
   */
  position?: string;

  /**
   * to be deprecated
   *
   * @generated from field: optional uint64 pickup_location_id = 7 [json_name = "pickup_location_id"];
   */
  pickup_location_id?: string;

  /**
   * Deprecated: replaces the whole set with this single group. Send
   * container_group_ids instead.
   *
   * @generated from field: optional uint64 container_group_id = 8 [json_name = "container_group_id"];
   */
  container_group_id?: string;

  /**
   * Replaces the contact's groups outright when non-empty. An empty list means
   * "leave the links alone", because proto2 cannot tell it apart from an unset
   * field - whether a contact belongs to a site or to the organization as a
   * whole is decided when it is created.
   *
   * @generated from field: repeated uint64 container_group_ids = 9 [json_name = "container_group_ids"];
   */
  container_group_ids?: string[];

  /**
   * Gate for automatic notifications to this person, and to their platform
   * user if one matches. Unset leaves the current value unchanged.
   *
   * @generated from field: optional bool notifications_enabled = 10 [json_name = "notifications_enabled"];
   */
  notifications_enabled?: boolean;
};

/**
 * Describes the message raccoonai.ContactUpdate.
 * Use `create(ContactUpdateSchema)` to create a new message.
 */
export const ContactUpdateSchema: GenMessage<ContactUpdate, {jsonType: ContactUpdateJson}> = /*@__PURE__*/
  messageDesc(file_contact, 2);

/**
 * @generated from message raccoonai.ContactList
 */
export type ContactList = Message<"raccoonai.ContactList"> & {
  /**
   * @generated from field: repeated raccoonai.Contact contacts = 1;
   */
  contacts: Contact[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  listInfo?: ListInfo;
};

/**
 * @generated from message raccoonai.ContactList
 */
export type ContactListJson = {
  /**
   * @generated from field: repeated raccoonai.Contact contacts = 1;
   */
  contacts?: ContactJson[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  list_info?: ListInfoJson;
};

/**
 * Describes the message raccoonai.ContactList.
 * Use `create(ContactListSchema)` to create a new message.
 */
export const ContactListSchema: GenMessage<ContactList, {jsonType: ContactListJson}> = /*@__PURE__*/
  messageDesc(file_contact, 3);

